/* No framework or global theme handlers. Safe if multiple sections load it. */
(() => {
  if (customElements.get('ft-gifting-tabs')) return;
  class FastachiGiftingTabs extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
      const list = this.querySelector('[data-tab-list]');
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-label', list.dataset.label || 'Personalization');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.addEventListener('click', () => this.select(index), { signal });
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') target = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.tabs.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          this.select(target);
          this.tabs[target].focus();
        }, { signal });
      });
      this.panels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.tabIndex = 0;
      });
      this.setAttribute('data-enhanced', '');
      this.select(0);
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel === event.target || panel.contains(event.target));
        if (index >= 0) this.select(index);
      }, { signal });
    }
    select(index) {
      this.tabs.forEach((tab, current) => {
        const selected = current === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        this.panels[current].hidden = !selected;
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('ft-gifting-tabs', FastachiGiftingTabs);
})();
